import config from '../config';

/**
 * Configuration for Gladly Help Center integration.
 */
const gladly = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      /**
       * The external script source URL for Gladly Help Center.
       */
      scriptSrc:
        'https://cdn.gladly.com/assets/help-center/dff0751a1623d59bc57214085f752798bf3ccc40/helpcenter.js'
    }
  },
  'UGG-US': {
    default: {
      scriptSrc:
        'https://cdn.gladly.com/assets/help-center/abbd48e0001a721d86b419a24b1c754e3c57b6e7/helpcenter.js'
    }
  },
  'HOKA-US': {
    default: {
      scriptSrc:
        'https://cdn.gladly.com/assets/help-center/abbd48e0001a721d86b419a24b1c754e3c57b6e7/helpcenter.js'
    }
  },
  'TEVA-US': {
    default: {
      scriptSrc:
        'https://cdn.gladly.com/assets/help-center/dff0751a1623d59bc57214085f752798bf3ccc40/helpcenter.js'
    }
  }
});

export default gladly;
